// Immunizations subsection form field enum
export enum ImmunizationsFormField {
  IMMUNIZATIONS_HEP_B = 'medicalBackground/immunizations/hepB',
  IMMUNIZATIONS_HEP_B_DATE = 'medicalBackground/immunizations/hepBDate',
  IMMUNIZATIONS_MENINGOCOCCAL = 'medicalBackground/immunizations/meningococcal',
  IMMUNIZATIONS_MENINGOCOCCAL_DATE = 'medicalBackground/immunizations/meningococcalDate',
  IMMUNIZATIONS_COVID_19 = 'medicalBackground/immunizations/covid19',
  IMMUNIZATIONS_COVID_19_DATE = 'medicalBackground/immunizations/covid19Date',
  IMMUNIZATIONS_DTAP = 'medicalBackground/immunizations/dtap',
  IMMUNIZATIONS_DTAP_DATE = 'medicalBackground/immunizations/dtapDate',
  IMMUNIZATIONS_HPV = 'medicalBackground/immunizations/hpv',
  IMMUNIZATIONS_HPV_DATE = 'medicalBackground/immunizations/hpvDate',
  IMMUNIZATIONS_RSV = 'medicalBackground/immunizations/rsv',
  IMMUNIZATIONS_RSV_DATE = 'medicalBackground/immunizations/rsvDate',
  IMMUNIZATIONS_NOTES = 'medicalBackground/immunizations/notes'
}
